import { Divider } from '@mui/material';
import React from 'react';
import Link from 'next/link';

const navigation = {
    main: [
        { name: 'Privacy Policy', href: '/privacy-policy' },
        { name: 'Cookie Policy', href: '/cookie-policy' },
        { name: 'Terms of Use', href: '/terms-of-use' },
    ],
    social: [
        {
            name: 'Facebook',
            href: 'https://www.facebook.com/pg/KingdomAdvisors',
            icon: (props) => (
                <svg fill="currentColor" viewBox="0 0 24 24" {...props}>
                    <path
                        fillRule="evenodd"
                        d="M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.878v-6.987h-2.54V12h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V12h2.773l-.443 2.89h-2.33v6.988C18.343 21.128 22 16.991 22 12z"
                        clipRule="evenodd"
                    />
                </svg>
            ),
        },
        {
            name: 'Instagram',
            href: 'https://www.instagram.com/kingdomadvisors/',
            icon: (props) => (
                <svg fill="currentColor" viewBox="0 0 24 24" {...props}>
                    <path d="M7.75 2h8.5A5.75 5.75 0 0 1 22 7.75v8.5A5.75 5.75 0 0 1 16.25 22h-8.5A5.75 5.75 0 0 1 2 16.25v-8.5A5.75 5.75 0 0 1 7.75 2zm6.5 2a.75.75 0 1 0 0 1.5h.75a.75.75 0 1 0 0-1.5h-.75zm-6.5 1a4.25 4.25 0 0 0-4.25 4.25v6.5A4.25 4.25 0 0 0 7.75 20h8.5A4.25 4.25 0 0 0 20 15.75v-6.5A4.25 4.25 0 0 0 16.25 5h-8.5zm4.25 2a5 5 0 1 1 0 10 5 5 0 0 1 0-10zm0 1.5a3.5 3.5 0 1 0 0 7 3.5 3.5 0 0 0 0-7z" />
                </svg>
            ),
        },
        {
            name: 'Linkedin',
            href: 'https://www.linkedin.com/company/kingdom-advisors',
            icon: (props) => (
                <svg fill="currentColor" viewBox="0 0 448 512" {...props}>
                    <path
                        fillRule="evenodd"
                        d="M100.28 448H7.4V148.9h92.88zM53.79 108.1C24.09 108.1 0 83.5 0 53.8a53.79 53.79 0 0 1 107.58 0c0 29.7-24.1 54.3-53.79 54.3zM447.9 448h-92.68V302.4c0-34.7-.7-79.2-48.29-79.2-48.29 0-55.69 37.7-55.69 76.7V448h-92.78V148.9h89.08v40.8h1.3c12.4-23.5 42.69-48.3 87.88-48.3 94 0 111.28 61.9 111.28 142.3V448z"
                        clipRule="evenodd"
                    />
                </svg>
            ),
        },
        {
            name: 'Twitter',
            href: 'http://twitter.com/KingdomAdvisors',
            icon: (props) => (
                <svg fill="currentColor" viewBox="0 0 24 24" {...props}>
                    <path d="M8.29 20.251c7.547 0 11.675-6.253 11.675-11.675 0-.178 0-.355-.012-.53A8.348 8.348 0 0022 5.92a8.19 8.19 0 01-2.357.646 4.118 4.118 0 001.804-2.27 8.224 8.224 0 01-2.605.996 4.107 4.107 0 00-6.993 3.743 11.65 11.65 0 01-8.457-4.287 4.106 4.106 0 001.27 5.477A4.072 4.072 0 012.8 9.713v.052a4.105 4.105 0 003.292 4.022 4.095 4.095 0 01-1.853.07 4.108 4.108 0 003.834 2.85A8.233 8.233 0 012 18.407a11.616 11.616 0 006.29 1.84" />
                </svg>
            ),
        },
    ],
}

export default function PageFooter() {
    return (
        <footer className="bg-primary-500">
            <div className="mx-auto max-w-7xl py-8 px-6 w-full">
                <div className='grid grid-cols-1 md:grid-cols-3 gap-3'>
                    <div className='space-y-2 flex flex-col'>
                        <Link legacyBehavior href={'/partners'}>
                            <a className="leading-6 text-white hover:text-gray-500">
                                Partners
                            </a>
                        </Link>
                        <Link legacyBehavior href={'/about'}>
                            <a className="leading-6 text-white hover:text-gray-500">
                                About
                            </a>
                        </Link>
                        <Link legacyBehavior href={'/get-certified/ethics-and-enforcement'}>
                            <a className="leading-6 text-white hover:text-gray-500">
                                Certification Renewal, Ethics, and Enforcement
                            </a>
                        </Link>
                    </div>
                    <div className='flex justify-center items-center'>
                        <a href={'https://www.ecfa.org/MemberProfile.aspx?ID=56443'} target="_blank" rel="noreferrer" >
                            <img
                                className='h-16 w-16'
                                src='/static/images/ecfa.png'
                            />
                        </a>
                    </div>
                    <div className='space-y-2 md:text-right'>
                        <div className='text-white'>3301 Windy Ridge Pkwy SE, Suite 50</div>
                        <div className='text-white'>Atlanta, GA 30339-8598</div>
                        <div className='text-white'>404.497.7680</div>
                    </div>
                </div>
                <Divider className='bg-white my-8' />
                <nav className="-mb-6 columns-2 sm:flex sm:justify-center sm:space-x-12" aria-label="Footer">
                    {navigation.main.map((item) => (
                        <div key={item.name} className="pb-6">
                            <Link legacyBehavior href={item.href}>
                                <a className="leading-6 text-white hover:text-gray-500">
                                    {item.name}
                                </a>
                            </Link>
                        </div>
                    ))}
                </nav>
                <div className="mt-10 flex justify-center space-x-10">
                    {navigation.social.map((item) => (
                        <a key={item.name} href={item.href} target="_blank" rel="noreferrer" className="text-white hover:text-gray-500">
                            <span className="sr-only">{item.name}</span>
                            <item.icon className="h-6 w-6" aria-hidden="true" />
                        </a>
                    ))}
                </div>
                <div className="mt-10 text-center text-xs leading-5 text-white">
                    &copy; {new Date().getFullYear()} Kingdom Advisors, Inc. All rights reserved.
                </div>
            </div>
        </footer>
    )
}
